import React from 'react';
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { getFormErrorMessage, validateNotEqual } from '../../../config/global';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Spinner } from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';

import { useDataTableContext } from '../../Contexts/DataTableContext';
import { useCreateCampaignMutation } from '../../../queries';

import { useSelector, useDispatch } from 'react-redux';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';

const Create = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const { openDialog, disableBtn, layer } = useSelector((state) => state.global);

    const { control, formState: { errors }, handleSubmit } = useForm();
    const { isInteractiveCampaign } = useDataTableContext();
    const interactive = window.location.pathname.includes("interactive")
        ? 1
        : 0;
    const createCampaign = useCreateCampaignMutation();

    const hideDialog = () => {
        dispatch(toggleDialog("createCampaign"));
    }

    const onSubmit = async (data) => {
        await createCampaign.mutateAsync({
            "name": data.name,
            "is_interactive": interactive
        })
    };

    return (
        <Dialog visible={openDialog.createCampaign} breakpoints={{ '960px': '95vw' }} style={{ width: '600px' }} header={t('show.show_create_campaign')} modal className="p-fluid" onHide={hideDialog}>
            <form onSubmit={handleSubmit(onSubmit)} className=" d-flex flex-column align-items-center">
                <div className={`col-12 px-3 my-5  w-75`}>
                    <div className="field">
                        <label className="form-label">{t('form.name')}</label>
                        <span className="p-float-label">
                            <Controller name="name" control={control}
                                rules={{ required: t('show.show_name_required'), validate: validateNotEqual }}
                                render={({ field, fieldState }) => (
                                    <InputText id={field.name} {...field} autoFocus
                                        className={classNames({ 'p-invalid': fieldState.invalid })} />
                                )} />
                        </span>
                        {getFormErrorMessage('name', errors)}
                    </div>
                </div>

                <div className="col-12 mt-3 d-flex justify-content-center py-3 border-top ">
                    <button type="reset" className="btn btn-label-secondary me-3" data-bs-dismiss="modal" aria-label={t('buttons.cancel')} disabled={disableBtn} onClick={hideDialog}>{t('buttons.cancel')}</button>
                    <button href='/campaigns/list' type="submit" className="btn btn-primary me-2" disabled={disableBtn}>
                        {disableBtn ?
                            <Spinner variant="white" as="span" animation="border" size="sm" role="status" className='mx-3' aria-hidden="true" />
                            :
                            t('buttons.create')
                        }
                    </button>
                </div>
            </form>
        </Dialog>
    );
};
export default Create;
